import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const useScrollToTopOnUrlChange = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (document.documentElement.scrollTop !== 0) {
      window.scrollTo(0, 0);
    }
  }, [pathname]);

  return null;
};
